module.exports = __webpack_public_path__ + "files/e687c6a087841e8a106cdd6eb1411a56.png";